import RetryWorker from '../../../../common/utils/RetryWorker';
import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';
import ErrorHandle from '../../../../common/utils/ErrorHandle';

export default {
	bookingInit({
        commit
    }) {
        // Create Retry Worker
        return new Promise((mainResolve, mainReject) => {
            new RetryWorker(10, 1000, 
                function(){
                    return new Promise((resolve, reject) => {
                        resolve(localStorage.AuthToken && localStorage.BasicDetails && JSON.parse(localStorage.BasicDetails));
                    });
                },
                function(){
                    window.axios.defaults.headers.common['Authorization'] = localStorage.AuthToken;
                    const data = JSON.parse(localStorage.BasicDetails);
                    const profile = {
                        firstName: data.firstname,
                        lastName: data.lastname,
                        email: data.email,
                        phone: data.phone,
                        type: data.type
                    };
                    commit('SET_PERSONAL_INFO', profile);
                    mainResolve();
                },
                function(){
                }
            ).doWork();
        });
    },
    ribbonNotification({
        commit
    }) {
        axios.get(process.env.MIX_API_URL + 'cms/ui-setting/ribbon-notification')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(data.list){
                    commit('SET_RIBBON_NOTIFICATION', {
                        visible: data.list[0].is_visible,
                        bg_color: data.list[0].ribbon_color,
                        text_color: data.list[0].ribbon_text
                    });
                }
            })
            .catch(() => console.log('Error when get ribbon setting from api'));
        },
    mainUI({
        commit
    }) {
        axios.get(process.env.MIX_API_URL + 'cms/ui-setting/main-ui-setting')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(data.list){
                    var logoPathAttribute;
                    try {
                        logoPathAttribute = JSON.parse(data.list[0].logo_path_attribute) || {alt: '', title: ''};
                    } catch (error) {
                        logoPathAttribute = {alt: '', title: ''};
                    }
                    commit('SET_MAIN_UI', {
                        header_bg_color: data.list[0].header_bg_color,
                        logo_path: data.list[0].logo_path,
                        logo_path_attribute: logoPathAttribute,
                        main_site_button_text: data.list[0].main_site_button_text,
                        main_site_button_color: data.list[0].main_site_button_color,
                        main_site_link: data.list[0].main_site_link,
                        landing_page_image:data.list[0].landing_page_image_path,
                        banner_image: data.list[0].banner_image_path,
                        banner_gradient_light: data.list[0].banner_gradient_light,
                        banner_gradient_dark: data.list[0].banner_gradient_dark,
                        button_color: data.list[0].button_color,
                        button_text_color: data.list[0].button_text_color,
                        breadcrumbs: data.list[0].landing_page_breadcrumbs,
                        calendar_color: data.list[0].calendar_color ? data.list[0].calendar_color : "blue" //gray, red, orange, yellow, green, teal, blue, indigo, purple, pink MOVE THIS TO VOYAGER
                    });
                }
            })
            .catch(e => console.error('Error when get Main UI setting from api', helper.errorCatch(e)));
    },
    searchInstruction({
        commit
    }) {
        axios.get(process.env.MIX_API_URL + 'cms/ui-setting/search-instruction')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(data.list){
                    commit('SET_SEARCH_INSTRUCTION', {
                        search_instruction_one: data.list[0].search_instruction_one,
                        search_instruction_two: data.list[0].search_instruction_two,
                    });
                }
            })
            .catch(() => console.log('Error when get search intruction'));
        },
    getFavorites({ state, commit }) {
        commit('SET_FAVORITES', {
            list: [],
            error: '',
            loading: true,
            fetched: false,
        });
        axios.get(process.env.MIX_API_URL + 'list-favorites', {
            params: {
                email: state.personalInfo.email
            }
        })
        .then(response => new ResponseDataExtractor(response).data)
        .then(data => {
            commit('SET_FAVORITES', {
                list: helper.addressTransform(data.addresses),
                loading: false,
                fetched: true
            });
        })
        .catch(e => {
            commit('SET_FAVORITES', {
                error: helper.errorCatch(e),
                loading: false,
                fetched: false
            })
        });
    },
    postFavorite({ state, commit }, [address, actionName]) {
        const urlPath = actionName === 'add-favorite' ? actionName : 'remove-favorite';
        commit('SET_FAVORITES', {
            error: '',
            saving: true
        });
        return axios.post(process.env.MIX_API_URL + urlPath, {
            email: state.personalInfo.email,
            addressId: address.id,
        })
        .then(() => {
            // notify saved
            commit('SET_FAVORITES', {
                saving: false,
                list: actionName === 'add-favorite' ? [ ...state.favorites.list, address ] : [ ...state.favorites.list.filter(f => f.id !== address.id) ]
            });
        })
        .catch(e => {
            // notify saving failed
            commit('SET_FAVORITES', {
                error: helper.errorCatch(e),
                saving: false
            });
        });
    },
    addressSearch({ commit, state }, [address_part, limit]) {
        if (this.onGoingRequest) {
            this.onGoingRequest.cancel('I forcefully canceled the previous requests')
        }
        commit('SET_SEARCHED_ADDRESSES', {
            list: [],
            error: '',
            loading: true,
            fetched: false,
        });
        const reqSource = axios.CancelToken.source();

        var firstQuery = address_part, secondQuery
        var firstData, secondData

        // Check for any abbreviations in the search string
        const addressAbbreviations = state.streetAbbreviations.list
        if(addressAbbreviations && addressAbbreviations.length > 0){
            let firstQueryParts = firstQuery.split(" ")

            for (let i = addressAbbreviations.length - 1; i >= 0; i--) { // Walk in Reverse Priority
                if(secondQuery){
                    break
                }
                let addressAbbreviation = addressAbbreviations[i]
                for (let i = 0; i < firstQueryParts.length; i++) {
                    let firstQueryPart = firstQueryParts[i].toLowerCase()
                    if(firstQueryPart === addressAbbreviation.abbreviation.toLowerCase()){
                        secondQuery = firstQuery.toLowerCase().split(firstQueryPart).join(addressAbbreviation.full_name)
                        break
                    }
                    if(firstQueryPart === addressAbbreviation.full_name.toLowerCase()){
                        secondQuery = firstQuery.toLowerCase().split(firstQueryPart).join(addressAbbreviation.abbreviation)
                        break
                    }
                }
            }
        }
        axios.get(process.env.MIX_API_URL + 'address-search', {
            params: {
                address_part : firstQuery,
                limit,
                portal: helper.getPortalName()
            },
            cancelToken: reqSource.token
        })
        .then(response => {
            firstData = new ResponseDataExtractor(response).data

            if(secondQuery){
                return axios.get(process.env.MIX_API_URL + 'address-search', {
                    params: {
                        address_part : secondQuery,
                        limit,
                        portal: helper.getPortalName()
                    },
                    cancelToken: reqSource.token
                })
            }
        })
        .then(response => {
            var addresses = firstData.addresses
            if(response){
                secondData = new ResponseDataExtractor(response).data

                addresses.push(...secondData.addresses)
            }

            commit('SET_SEARCHED_ADDRESSES', {
                list: helper.addressTransform(addresses),
                error: '',
                loading: false,
                fetched: true,
            });
        })
        .catch(e => {
            const { statusCode, error } = new ErrorHandle(e).format;
            if(statusCode == 408) {
                axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                    'request_uri': 'address-search'
                });
            }

            commit('SET_SEARCHED_ADDRESSES', {
                list: [],
                error,
                loading: false,
                fetched: false,
            });
        });
        this.onGoingRequest = reqSource;
    },
    setActiveAddress({ commit }, address) {
        commit('SET_ACTIVE_ADDRESS', address);
        commit('SET_SEARCHED_ADDRESSES', { list: [], fetched: false })
    },
    clearSearchedAddresses({ commit }) {
        commit('SET_SEARCHED_ADDRESSES', {
            list: [],
            error: '',
            loading: false,
            fetched: false,
        });
    },
    clearFavorites({ commit }) {
        commit('SET_FAVORITES', {
            list: [],
            error: '',
            loading: false,
            fetched: false,
            saving: false
        });
    },
    getBinType({ }, payload) {
      return axios.get(process.env.MIX_API_URL + 'cms/bin-schedule-setting/bin-type')
          .then(response => new ResponseDataExtractor(response).data)
          .catch(() => console.log('Error when get bin type from api'));
    },
}